import React from 'react';
import { translate } from '@data/translations';
import { Reservation } from '../resController';
import BasicSRCSettings1 from '../../roomInfo/components/basicSRCSettingsModal1';
import Tooltip from '@components/tooltip/tooltip';

interface ProxyRoomAccessCodesProps {
    reservation: Reservation;
    history: any;
}

const ProxyRoomAccessCodes: React.FC<ProxyRoomAccessCodesProps> = ({ reservation }) => {
    const [showOnlyOneSRC, setShowOnlyOneSRC] = React.useState(false as boolean);
    const [activeControllerTab, setActiveControllerTab] = React.useState(0);

    return (
        <div className='reservation-inner-height'>
            {/* Checkbox za All controllers */}
            {reservation?.RoomInfo?.remoteDeviceId &&
            (reservation?.RoomInfo?.remoteDeviceId2 || reservation?.RoomInfo?.remoteDeviceId3) ? (
                <div className="mb-8p mt-8p">
                    <label className="checkbox-container">
                        <input
                            type="checkbox"
                            checked={showOnlyOneSRC}
                            onChange={(e) => setShowOnlyOneSRC(e.target.checked)}
                        />
                        <span className="checkmark"></span>
                        {translate('Apply to all controllers')}
                        <Tooltip
                            message={translate(`If checked, the guest card is programmed to all controllers at once.`)}
                        >
                            <i className="fa fa-info-circle ml-4p"></i>
                        </Tooltip>
                    </label>
                </div>
            ) : null}

            {/* Tabovi za kontrolere */}
            {!showOnlyOneSRC && (
                <div className="controller-tabs mb-8p">
                    {reservation?.RoomInfo?.remoteDeviceId && (
                        <button
                            className={activeControllerTab === 0 ? 'active' : ''}
                            onClick={() => setActiveControllerTab(0)}
                        >
                            {translate('Main Controller')}
                        </button>
                    )}
                    {reservation?.RoomInfo?.remoteDeviceId2 && (
                        <button
                            className={activeControllerTab === 1 ? 'active' : ''}
                            onClick={() => setActiveControllerTab(1)}
                        >
                            {translate('Controller 2')}
                        </button>
                    )}
                    {reservation?.RoomInfo?.remoteDeviceId3 && (
                        <button
                            className={activeControllerTab === 2 ? 'active' : ''}
                            onClick={() => setActiveControllerTab(2)}
                        >
                            {translate('Controller 3')}
                        </button>
                    )}
                </div>
            )}

            {/* Prikaz kontrolera */}
            {showOnlyOneSRC ? (
                // Prikaz samo prvog kontrolera za sve
                <BasicSRCSettings1
                    roomInfoId={reservation?.RoomInfo?.id}
                    key={`all-${reservation?.RoomInfo?.id}`}
                    reservation={reservation}
                    remoteDeviceId={reservation?.RoomInfo?.remoteDeviceId}
                    showOnlyOneSRC={true}
                />
            ) : (
                // Prikaz po tabovima
                <>
                    {activeControllerTab === 0 && reservation?.RoomInfo?.remoteDeviceId && (
                        <BasicSRCSettings1
                            roomInfoId={reservation?.RoomInfo?.id}
                            key={`controller1-${reservation?.RoomInfo?.id}`}
                            reservation={reservation}
                            remoteDeviceId={reservation?.RoomInfo?.remoteDeviceId}
                            showOnlyOneSRC={false}
                        />
                    )}
                    {activeControllerTab === 1 && reservation?.RoomInfo?.remoteDeviceId2 && (
                        <BasicSRCSettings1
                            roomInfoId={reservation?.RoomInfo?.id}
                            key={`controller2-${reservation?.RoomInfo?.id}`}
                            reservation={reservation}
                            remoteDeviceId={reservation?.RoomInfo?.remoteDeviceId2}
                            showOnlyOneSRC={false}
                        />
                    )}
                    {activeControllerTab === 2 && reservation?.RoomInfo?.remoteDeviceId3 && (
                        <BasicSRCSettings1
                            roomInfoId={reservation?.RoomInfo?.id}
                            key={`controller3-${reservation?.RoomInfo?.id}`}
                            reservation={reservation}
                            remoteDeviceId={reservation?.RoomInfo?.remoteDeviceId3}
                            showOnlyOneSRC={false}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default ProxyRoomAccessCodes;
